import React from 'react';
import PropTypes from 'prop-types';
import CopyButton from '../../admin/components/common/CopyButton';

export default function AccessKeyDisplay({
  accessKeyToken,
  accessKey,
  accessDurationUntil,
  variant = 'default',
  showUrl = true,
}) {
  const token = accessKeyToken || accessKey;
  const isExpired = accessDurationUntil && new Date(accessDurationUntil) <= new Date();

  if (!token || isExpired) return <span>—</span>;

  const fullUrl = `${window.location.origin}/assets/access_key/${token}`;

  if (variant === 'modal') {
    return (
      <div className="d-flex align-items-center gap-2">
        <div className="input-group">
          <input
            type="text"
            className="form-control font-monospace"
            value={fullUrl}
            readOnly
            style={{ fontSize: '0.875rem' }}
          />
          <CopyButton value={fullUrl} title="Copy access key URL" />
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center gap-2">
      {showUrl ? (
        <a className="font-monospace" href={fullUrl} target="_blank" rel="noopener noreferrer">
          {token}
        </a>
      ) : (
        <span className="font-monospace">{token}</span>
      )}
      <CopyButton value={fullUrl} title="Copy access key URL" />
    </div>
  );
}

AccessKeyDisplay.propTypes = {
  accessKeyToken: PropTypes.string,
  accessKey: PropTypes.string,
  accessDurationUntil: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'modal']),
  showUrl: PropTypes.bool,
};
